var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98396 2.43816C5.80599 2.68534 5.74253 2.99464 5.74253 3.19458H5.32012H4.89771C4.89771 2.85945 4.99477 2.36617 5.29835 1.94453C5.61744 1.50135 6.14555 1.16699 6.92529 1.16699H8.92468L12.1632 4.40553V4.5805V8.57331C12.1632 8.90843 12.0662 9.40172 11.7626 9.82336C11.4435 10.2665 10.9154 10.6009 10.1356 10.6009H6.92529C6.59017 10.6009 6.09688 10.5038 5.67524 10.2002C5.23206 9.88116 4.89771 9.35305 4.89771 8.57331V3.19458H5.32012H5.74253V8.57331C5.74253 9.0777 5.94323 9.35218 6.16888 9.51464C6.41606 9.69261 6.72536 9.75607 6.92529 9.75607H10.1356C10.64 9.75607 10.9145 9.55536 11.077 9.32972C11.2549 9.08254 11.3184 8.77324 11.3184 8.57331V4.75546L8.57474 2.01182H6.92529C6.42089 2.01182 6.14642 2.21252 5.98396 2.43816Z",
    fill: "#3D3962"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.55922 4.54156C2.99846 4.22531 3.51286 4.12402 3.86207 4.12402H4.70689C4.94019 4.12402 5.12931 4.31314 5.12931 4.54644C5.12931 4.77973 4.94019 4.96885 4.70689 4.96885H3.86207C3.64805 4.96885 3.31763 5.03653 3.05285 5.22717C2.80961 5.4023 2.59483 5.6979 2.59483 6.23609V11.3051C2.59483 11.5191 2.66251 11.8495 2.85315 12.1143C3.02828 12.3575 3.32388 12.5723 3.86207 12.5723H6.67816C6.89217 12.5723 7.22259 12.5046 7.48737 12.314C7.73061 12.1388 7.9454 11.8432 7.9454 11.3051V10.5383L8.79022 10.5381V11.3051C8.79022 12.1186 8.44179 12.6678 7.98101 12.9996C7.54177 13.3158 7.02736 13.4171 6.67816 13.4171H3.86207C3.04853 13.4171 2.4993 13.0687 2.16754 12.6079C1.85129 12.1687 1.75 11.6543 1.75 11.3051V6.23609C1.75 5.42256 2.09843 4.87333 2.55922 4.54156Z",
    fill: "#3D3962"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32739 1.58984H9.17222V4.15852H11.7409V5.00335H8.32739V1.58984Z",
    fill: "#3D3962"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDuplicate);
export default __webpack_public_path__ + "static/media/ic_duplicate.1f269e8a11a461505dbc3f818d993aca.svg";
export { ForwardRef as ReactComponent };